let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3l3Az")).then(() => parcelRequire('18iDn'));